const stateTranslate: Record<string, string> = {
  'STATE.VEHICLE.PURCHASED': 'Comprado',
  'STATE.VEHICLE.PRESENT': 'Consignación física',
  'STATE.VEHICLE.VIRTUAL': 'Consignación virtual',
}

export default stateTranslate
